import React from "react"
import { Redirect, Route, Switch, withRouter } from "react-router-dom"
import { AboutYourPartnerIntro } from "./aboutyourpartner/AboutYourPartnerIntro"
import { AboutYourPartnerName } from "./aboutyourpartner/AboutYourPartnerName"
import { AboutYourPartnerEmail } from "./aboutyourpartner/AboutYourPartnerEmail"
import { PartnerDateOfBirth } from "./aboutyourpartner/AboutYourPartnerDateOfBirth"
import { AboutYourPartnerSex } from "./aboutyourpartner/AboutYourPartnerSex"
import { AboutYourPartnerGenderIdentity } from "./aboutyourpartner/AboutYourPartnerGenderIdentity"
import { FeatureGate } from "utils/FeatureGate"

const AboutYourPartner = ({ history }) => (
  <Route path="/fle/partner">
    <Redirect from="/fle/partner" to="/fle/partner/intro" push={false} />

    <FeatureGate filter={(c) => !c.isPartnerEnabled}>
      <Redirect to="/fle/journey" />
    </FeatureGate>

    <Switch>
      <Route exact path="/fle/partner/intro">
        <AboutYourPartnerIntro next="/fle/partner/name" skip="/fle/journey" history={history} />
      </Route>
      <Route exact path="/fle/partner/name">
        <AboutYourPartnerName next="/fle/partner/email" history={history} />
      </Route>
      <Route exact path="/fle/partner/email">
        <AboutYourPartnerEmail next="/fle/partner/date-of-birth" history={history} />
      </Route>
      <Route exact path="/fle/partner/date-of-birth">
        <PartnerDateOfBirth next="/fle/partner/sex" history={history} />
      </Route>
      <Route exact path="/fle/partner/sex">
        <AboutYourPartnerSex next="/fle/partner/gender-identity" history={history} />
      </Route>
      <Route exact path="/fle/partner/gender-identity">
        <AboutYourPartnerGenderIdentity next="/fle/journey" history={history} />
      </Route>
    </Switch>
  </Route>
)

export default withRouter(AboutYourPartner)
